import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
    Paper,
    Typography,
    Chip,
    Card,
    CardContent,
    CardHeader,
    Avatar,
    Stack,
    Collapse,
    List,
    ListItem,
    Tooltip,
    IconButton,
    Divider,
} from "@mui/material";

import StarIcon from "@mui/icons-material/Star";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const ReviewPage = ({ examEmployeeId }) => {
    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const [openIndex, setOpenIndex] = useState(null);
    const [examInfo, setExamInfo] = useState(null);

    useEffect(() => {
        if (!examEmployeeId) return;
        axios.get(`/exam/review-exam/?examEmployeeId=${examEmployeeId}`, { withCredentials: true })
            .then((response) => {
                const data = response.data;
                console.log("API Response:", data, "qqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");

                const transformedQuestions = data.questions?.map((q) => {
                    let transformedQ = { ...q };

                    if (q.type === 0) {
                        if (q._raw?.question_type_id === 0) {
                            if (q.answer && q.answer.includes(",")) {
                                transformedQ.type = "MSQ";
                            } else if (!q.options || q.options.length === 0) {
                                transformedQ.type = "FILL in the Blanks";
                            } else {
                                transformedQ.type = "MCQ";
                            }
                        }
                    }

                    if (q._raw?.options && q._raw.options.length > 0) {
                        transformedQ.options = q._raw.options;
                    }

                    transformedQ.mandatory = q._raw?.is_mandatory === 1;

                    // const status = (q.status || "").toLowerCase().trim();

                    // transformedQ.status = status;

                    // transformedQ.isAnswered = status === "answered";
                    // transformedQ.isMarked = status === "marked";
                    // transformedQ.isNotAnswered =
                    //     status === "not-answered" || status === "";

                    const status = (q.status || "").toLowerCase().trim();

                    transformedQ.status = status;

                    transformedQ.isAnswered =
                        status === "answered" ||
                        status === "answered-marked";

                    transformedQ.isMarked =
                        status === "marked" ||
                        status === "answered-marked";

                    transformedQ.isNotAnswered =
                        status === "not-answered" ||
                        status === "";
                    return transformedQ;
                });

                setQuestions(transformedQuestions || []);
                setExamInfo(data.exam);
            })
            .catch((err) => {
                console.error("Failed to fetch review data", err);
                setQuestions([]);
            });
    }, [examEmployeeId]);

    const total = questions.length;


    // const getStatusChip = (q) => {
    //     if (q.isAnswered) {
    //         return (
    //             <Chip
    //                 label="Answered"
    //                 size="small"
    //                 icon={<CheckCircleIcon />}
    //                 sx={{
    //                     bgcolor: "rgba(34,197,94,0.12)",
    //                     color: "#166534",
    //                     fontWeight: 700,
    //                 }}
    //             />
    //         );
    //     }

    //     if (q.isMarked) {
    //         return (
    //             <Chip
    //                 label="Marked"
    //                 size="small"
    //                 icon={<StarIcon />}
    //                 sx={{
    //                     bgcolor: "rgba(245,158,11,0.15)",
    //                     color: "#92400e",
    //                     fontWeight: 700,
    //                 }}
    //             />
    //         );
    //     }

    //     return (
    //         <Chip
    //             label="Not Answered"
    //             size="small"
    //             sx={{
    //                 bgcolor: "rgba(0,0,0,0.06)",
    //                 fontWeight: 700,
    //             }}
    //         />
    //     );
    // };

    const getStatusChip = (q) => {
        if (q.status === "answered-marked") {
            return (
                <Chip
                    label="Answered & Marked"
                    size="small"
                    icon={<StarIcon />}
                    sx={{
                        bgcolor: "rgba(245,158,11,0.15)",
                        color: "#92400e",
                        fontWeight: 700,
                    }}
                />
            );
        }

        if (q.isAnswered) {
            return (
                <Chip
                    label="Answered"
                    size="small"
                    icon={<CheckCircleIcon />}
                    sx={{
                        bgcolor: "rgba(34,197,94,0.12)",
                        color: "#166534",
                        fontWeight: 700,
                    }}
                />
            );
        }

        if (q.isMarked) {
            return (
                <Chip
                    label="Not-Answered & Marked"
                    size="small"
                    icon={<StarIcon />}
                    sx={{
                        bgcolor: "rgba(245,158,11,0.15)",
                        color: "#92400e",
                        fontWeight: 700,
                    }}
                />
            );
        }

        return (
            <Chip
                label="Not Answered"
                size="small"
            />
        );
    };
    const isOptionSelected = (q, optionKey) => {
        if (!q.userAnswer) return false;

        if (q.type === "MCQ") {
            return q.userAnswer === optionKey;
        } else if (q.type === "MSQ") {
            if (Array.isArray(q.userAnswer)) {
                return q.userAnswer.includes(optionKey);
            } else if (typeof q.userAnswer === "string") {
                return q.userAnswer.split(",").includes(optionKey);
            }
        }
        return false;
    };

    const getUserAnswerText = (q) => {
        if (!q.attempted) return "Not attempted";

        if (q.type === "FILL in the Blanks") {
            return q.userAnswer || "Not attempted";
        }

        if (q.userAnswer && q._raw?.options) {
            if (q.type === "MCQ") {
                const option = q._raw.options.find((opt) => opt.key === q.userAnswer);
                return option ? option.value : q.userAnswer;
            } else if (q.type === "MSQ") {
                const answerKeys = Array.isArray(q.userAnswer)
                    ? q.userAnswer
                    : q.userAnswer.split(",");

                const answerTexts = answerKeys.map((key) => {
                    const option = q._raw.options.find((opt) => opt.key === key);
                    return option ? option.value : key;
                });

                return answerTexts.join(", ");
            }
        }

        return Array.isArray(q.userAnswer)
            ? q.userAnswer.join(", ")
            : q.userAnswer;
    };

    const textWrappingStyles = {
        overflowWrap: "break-word",
        wordBreak: "normal",
        hyphens: "auto",
    };

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
                bgcolor: "#f5f8fb",
                // Reduced padding for very small screens
                px: { xs: 0.5, sm: 1.5, md: 3, lg: 4 },
                py: { xs: 1, sm: 2.5, md: 4 },
            }}
        >
            {/* HEADER - Optimized for small screens */}
            <Paper
                elevation={4}
                sx={{
                    borderRadius: 3,
                    background: '#0191C8',
                    color: 'white',
                    p: { xs: 3, sm: 4 },
                    mb: 4,
                }}
            >
                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    gap={2}
                >
                    <Box>
                        <Box display="flex" alignItems="center" mb={2}>
                            <Typography variant="h4" fontWeight={800} ml={1}>
                                Review Panel
                            </Typography>
                        </Box>

                        {examInfo && (
                            <Typography variant="subtitle1" sx={{ opacity: 0.95, mb: 1 }}>
                                {examInfo.Title} - {examInfo.Topic}
                            </Typography>
                        )}

                        <Typography variant="subtitle1" sx={{ opacity: 0.95 }}>
                            A detailed, question-by-question review of your responses.
                        </Typography>
                    </Box>
                </Box>

                {/* LEGEND - Matching first code exactly */}
                <Paper elevation={3} sx={{ mt: 3, p: 2, bgcolor: 'white', borderRadius: 2 }}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} flexWrap="wrap" alignItems="center">
                        <Chip label={`${total} Total`} sx={{ bgcolor: '#0191C8', color: 'white', fontWeight: 700, px: 2 }} />

                        <Stack direction="row" alignItems="center" gap={1}>
                            <StarIcon sx={{ color: '#f59e0b', fontSize: 20 }} />
                            <Typography variant="body2">Mandatory</Typography>
                        </Stack>

                        <Stack direction="row" alignItems="center" gap={1}>
                            <CheckCircleIcon fontSize="small" sx={{ color: '#22c55e' }} />
                            <Typography variant="body2">Attempted</Typography>
                        </Stack>

                        <Stack direction="row" alignItems="center" gap={1}>
                            <RadioButtonUncheckedIcon fontSize="small" sx={{ opacity: 0.7 }} />
                            <Typography variant="body2">Not attempted</Typography>
                        </Stack>
                    </Stack>
                </Paper>
            </Paper>

            {/* QUESTIONS CONTAINER */}
            <Box
                sx={{
                    // Adjusted height calculation for small screens
                    height: { xs: "calc(100vh - 220px)", sm: "calc(100vh - 280px)", md: "calc(100vh - 320px)" },
                    overflowY: "auto",
                    // Remove right padding to use full width on small screens
                    pr: { xs: 0, sm: 1 },
                    "&::-webkit-scrollbar": { width: 5, height: 5 },
                    "&::-webkit-scrollbar-thumb": {
                        background: "rgba(0,0,0,0.24)",
                        borderRadius: 4,
                    },
                }}
            >
                <Stack
                    spacing={{ xs: 1.5, sm: 2.5, md: 3 }} // Reduced spacing on xs
                    pb={{ xs: 3, sm: 5 }}
                    sx={{
                        // Ensure cards take full width on small screens
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {questions.map((q, i) => {
                        const isCorrect = q.is_correct;

                        return (
                            <Card
                                key={q.id}
                                elevation={2}
                                sx={{
                                    borderRadius: { xs: 1.25, sm: 3 }, // Slightly smaller on xs
                                    width: "100%",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    transition: "all 0.18s",
                                    "&:hover": {
                                        boxShadow: { xs: 2, sm: 6 }, // Reduced shadow on xs
                                        transform: { xs: "none", sm: "translateY(-1px)" },
                                    },
                                    border: "1px solid rgba(0,0,0,0.09)",
                                    // Remove any margins to use full width
                                    mx: 0,
                                }}
                                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                            >
                                <CardHeader
                                    title={
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "row", sm: "row" }, // Keep row even on xs
                                                alignItems: { xs: "flex-start", sm: "center" },
                                                gap: { xs: 1, sm: 1.5 }, // Reduced gap on xs
                                                mb: { xs: 0.5, sm: 0 }, // Reduced margin
                                                width: "100%",
                                            }}
                                        >
                                            <Avatar
                                                sx={{
                                                    bgcolor: q.mandatory ? "#f59e0b" : "#2563eb",
                                                    width: { xs: 36, sm: 40 }, // Smaller on xs
                                                    height: { xs: 36, sm: 40 }, // Smaller on xs
                                                    fontSize: { xs: "1.1rem", sm: "1.25rem" }, // Smaller font
                                                    fontWeight: 800,
                                                    flexShrink: 0, // Prevent avatar from shrinking
                                                }}
                                            >
                                                {i + 1}
                                            </Avatar>

                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    minWidth: 0, // Important for text truncation
                                                }}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    fontWeight={700}
                                                    sx={{
                                                        fontSize: { xs: "0.85rem", sm: "1.02rem", md: "1.12rem" }, // Smaller on xs
                                                        lineHeight: 1.4,
                                                        ...textWrappingStyles,
                                                        // Ensure text doesn't overflow
                                                        overflow: "hidden",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: openIndex === i ? "unset" : 3,
                                                        WebkitBoxOrient: "vertical",
                                                        textOverflow: "ellipsis",
                                                    }}
                                                >
                                                    {q.question}
                                                </Typography>
                                                {q.mandatory && (
                                                    <StarIcon
                                                        sx={{
                                                            color: "#f59e0b",
                                                            fontSize: { xs: 18, sm: 20 }, // Smaller on xs
                                                            ml: { xs: 0.25, sm: 0.5 }, // Reduced margin
                                                            verticalAlign: "middle",
                                                            display: "inline-block",
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                    }
                                    subheader={
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontSize: { xs: "0.68rem", sm: "0.8rem" }, // Smaller on xs
                                                mt: 0.25, // Reduced margin
                                                display: "block",
                                            }}
                                        >
                                            {/* {q.type} */}
                                            {isCorrect !== undefined && (
                                                <span
                                                    style={{
                                                        marginLeft: "6px", // Reduced margin
                                                        color: isCorrect ? "#22c55e" : "#ef4444",
                                                        fontWeight: "bold",
                                                    }}
                                                />
                                            )}
                                        </Typography>
                                    }
                                    action={
                                        <Stack
                                            direction="row"
                                            spacing={0.5} // Reduced spacing
                                            alignItems="center"
                                            sx={{
                                                mr: { xs: -0.5, sm: 0 }, // Adjusted for better spacing
                                                flexShrink: 0, // Prevent from shrinking
                                            }}
                                        >
                                            {getStatusChip(q)}
                                            <IconButton
                                                size="small"
                                                sx={{
                                                    p: { xs: 0.25, sm: 1 }, // Smaller padding on xs
                                                    ml: -0.5, // Pull icon closer to chip
                                                }}
                                            >
                                                {openIndex === i ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                        </Stack>
                                    }
                                    sx={{
                                        alignItems: "flex-start",
                                        "& .MuiCardHeader-action": {
                                            alignSelf: "flex-start",
                                            mt: 0.25, // Reduced margin
                                            mr: { xs: -0.5, sm: 0 },
                                        },
                                        // Reduced padding for small screens
                                        px: { xs: 1, sm: 2 },
                                        py: { xs: 0.75, sm: 1.5 },
                                        pb: 0.75,
                                        // Ensure content doesn't wrap
                                        display: "flex",
                                        flexWrap: "nowrap",
                                    }}
                                />

                                <Collapse in={openIndex === i}>
                                    <CardContent sx={{
                                        pt: 0.25, // Reduced top padding
                                        pb: 2, // Reduced bottom padding
                                        px: { xs: 1, sm: 2 }, // Adjusted horizontal padding
                                    }}>
                                        {q._raw?.options && q._raw.options.length > 0 && (
                                            <>
                                                <Typography
                                                    variant="subtitle2"
                                                    fontWeight={700}
                                                    gutterBottom
                                                    sx={{
                                                        fontSize: { xs: "0.82rem", sm: "0.98rem" }, // Smaller on xs
                                                        mb: 1, // Reduced margin
                                                    }}
                                                >
                                                    Options
                                                </Typography>

                                                <List disablePadding>
                                                    {q._raw.options.map((opt, idx) => {
                                                        const isUserSelected = isOptionSelected(q, opt.key);

                                                        return (
                                                            <ListItem
                                                                key={idx}
                                                                sx={{
                                                                    mb: 1, // Reduced margin
                                                                    px: { xs: 1, sm: 2 }, // Reduced padding on xs
                                                                    py: { xs: 0.75, sm: 1.25 }, // Reduced padding on xs
                                                                    borderRadius: 1.5,
                                                                    border: isUserSelected
                                                                        ? "1.5px solid rgba(59,130,246,0.6)"
                                                                        : "1px solid rgba(0,0,0,0.15)",
                                                                    bgcolor: isUserSelected ? "rgba(59,130,246,0.05)" : "transparent",
                                                                    alignItems: "flex-start",
                                                                    flexDirection: "row",
                                                                    gap: 1, // Reduced gap
                                                                    ...textWrappingStyles,
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        fontSize: { xs: "0.8rem", sm: "0.92rem", md: "0.97rem" }, // Smaller on xs
                                                                        fontWeight: isUserSelected ? 700 : 500,
                                                                        lineHeight: 1.4,
                                                                        flex: 1,
                                                                        minWidth: 0,
                                                                        ...textWrappingStyles,
                                                                    }}
                                                                >
                                                                    {opt.key}. {opt.value}
                                                                </Typography>

                                                                {isUserSelected ? (
                                                                    <Tooltip title="Your selection">
                                                                        <CheckCircleIcon sx={{
                                                                            color: "#2563eb",
                                                                            fontSize: { xs: 18, sm: 20 }, // Smaller on xs
                                                                            mt: "2px" // Adjusted vertical alignment
                                                                        }} />
                                                                    </Tooltip>
                                                                ) : (
                                                                    <RadioButtonUncheckedIcon
                                                                        sx={{
                                                                            opacity: 0.45,
                                                                            fontSize: { xs: 18, sm: 20 }, // Smaller on xs
                                                                            mt: "2px" // Adjusted vertical alignment
                                                                        }}
                                                                    />
                                                                )}
                                                            </ListItem>
                                                        );
                                                    })}
                                                </List>
                                                <Divider sx={{ my: 2 }} /> {/* Reduced margin */}
                                            </>
                                        )}

                                        <Box sx={{ mt: { xs: 1.5, sm: 2.5 } }}> {/* Reduced top margin on xs */}
                                            <Typography
                                                variant="subtitle2"
                                                fontWeight={700}
                                                sx={{ fontSize: { xs: "0.82rem", sm: "0.98rem" } }} // Smaller on xs
                                            >
                                                Your Response
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    mt: 0.75, // Reduced margin
                                                    fontWeight: 600,
                                                    color: "#1404DE",
                                                    fontSize: { xs: "0.82rem", sm: "0.94rem", md: "1rem" }, // Smaller on xs
                                                    lineHeight: 1.5,
                                                    whiteSpace: "pre-wrap",
                                                    ...textWrappingStyles,
                                                }}
                                            >
                                                {getUserAnswerText(q)}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Collapse>
                            </Card>
                        );
                    })}
                </Stack>
            </Box>
        </Box>
    );
};

export default ReviewPage;
